export default "__VITE_ASSET__B13fUN$F__"